<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-id icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          Employee Master
          <div class="page-title-subheading">Manage the list of employees maintained in the HR portal.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 card">
    <div class="card-body">
      <div class="d-flex justify-content-end mb-3">
        <button
          type="button"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#addEmployeeModal"
          (click)="resetForAdd()"
        >
          <i class="fa fa-plus me-1"></i> Add Employee
        </button>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

      <div *ngIf="isLoading" class="text-center text-muted py-4">Loading employees...</div>

      <vio-table-v2
        *ngIf="!isLoading"
        [tableData]="employees"
        [tableConfig]="tableConfig"
      ></vio-table-v2>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="addEmployeeModal"
  tabindex="-1"
  aria-labelledby="addEmployeeModalLabel"
  aria-hidden="true"
  #addEmployeeModal
>
  <div class="modal-dialog">
    <div class="modal-content">
      <form (ngSubmit)="saveEmployee()" #employeeForm="ngForm">
        <div class="modal-header">
          <h5 class="modal-title" id="addEmployeeModalLabel">{{ newEmployee._id ? 'Edit Employee' : 'Add Employee' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" for="employeeName">Name <span class="text-danger">*</span></label>
            <input id="employeeName" type="text" class="form-control" name="name" [(ngModel)]="newEmployee.name" required />
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeEmpNo">Employee No. <span class="text-danger">*</span></label>
            <input
              id="employeeEmpNo"
              type="text"
              class="form-control"
              name="empNo"
              [(ngModel)]="newEmployee.empNo"
              [readonly]="!!newEmployee._id"
              required
            />
            <div class="form-text" *ngIf="newEmployee._id">
              Employee No. can't be changed here — pay slips and other documents are linked to it.
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeDob">Date of Birth</label>
            <input id="employeeDob" type="date" class="form-control" name="dob" [(ngModel)]="newEmployee.dob" />
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeDepartment">Department</label>
            <select id="employeeDepartment" class="form-select" name="department" [(ngModel)]="newEmployee.department">
              <option value="">-- Select Department --</option>
              <option *ngFor="let d of departments" [value]="d.name">{{ d.name }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeRole">Role</label>
            <select id="employeeRole" class="form-select" name="role" [(ngModel)]="newEmployee.role">
              <option value="">-- Select Role --</option>
              <option *ngFor="let r of roles" [value]="r.name">{{ r.name }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeBu">BU</label>
            <select id="employeeBu" class="form-select" name="bu" [(ngModel)]="newEmployee.bu">
              <option value="">-- Select BU --</option>
              <option *ngFor="let b of bus" [value]="b.name">{{ b.name }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeEsiNo">ESI No.</label>
            <input id="employeeEsiNo" type="text" class="form-control" name="esiNo" [(ngModel)]="newEmployee.esiNo" />
          </div>
          <div class="mb-3">
            <label class="form-label" for="employeeWhatsappNumber">WhatsApp Number</label>
            <input
              id="employeeWhatsappNumber"
              type="tel"
              class="form-control"
              name="whatsappNumber"
              [(ngModel)]="newEmployee.whatsappNumber"
              placeholder="e.g. +91 9876543210"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="!employeeForm.form.valid || isSaving">
            {{ isSaving ? (newEmployee._id ? 'Updating...' : 'Saving...') : (newEmployee._id ? 'Update Employee' : 'Save Employee') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="payslipListModal"
  tabindex="-1"
  aria-labelledby="payslipListModalLabel"
  aria-hidden="true"
  #payslipListModal
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="payslipListModalLabel">Documents — {{ selectedEmployeeName }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="payslipsErrorMessage" class="alert alert-danger" role="alert">{{ payslipsErrorMessage }}</div>

        <div *ngIf="isLoadingPayslips" class="text-center text-muted py-4">Loading pay slips...</div>

        <div *ngIf="!isLoadingPayslips && !employeePayslips.length && !payslipsErrorMessage" class="text-center text-muted py-4">
          No pay slips found for this employee.
        </div>

        <vio-table-v2
          *ngIf="!isLoadingPayslips && employeePayslips.length"
          [tableData]="employeePayslips"
          [tableConfig]="payslipTableConfig"
        ></vio-table-v2>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
